<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.wabaTemplate"
        @row-clicked="handleRowClicked"
        ref="RkmDataTable"
        tbody-tr-class="waba-template-row"
    >
        <template v-slot:cell(waba_template_status)="{item}">
            <span :class="statusDetails(item.waba_template_status).class">
                {{ statusDetails(item.waba_template_status).label }}
            </span>
        </template>
    </rkm-data-table>
</template>

<script>
export default {
    computed: {
        fields() {
            return [
                {key: 'waba_template_name', label: 'Nome', name: 'cadastro_waba_template.name', searchable: true, sortable: true},
                {key: 'waba_template_language', label: 'Idioma', name: 'cadastro_waba_template.language', searchable: true, sortable: true},
                {class: 'text-center', key: 'waba_template_status', label: 'Status', name: 'cadastro_waba_template.status', searchable: true, sortable: true},
                {class: 'text-center', key: 'waba_template_parameters_count', label: 'Parâmetros'},
                {class: 'text-center', key: 'waba_template_buttons_count', label: 'Botões'},
            ]
        },
    },
    inject: ['repositories'],
    methods: {
        refresh() {
            this.$refs.RkmDataTable.refresh()
        },
        handleRowClicked(item) {
            this.$emit('select', {
                name: item.waba_template_name,
                status: item.waba_template_status,
                statusDetails: this.statusDetails(item.waba_template_status),
            })
        },
        statusDetails(value) {
            const status = String(value || '').toUpperCase()
            const statuses = {
                APPROVED: {class: 'text-success', label: 'Aprovado'},
                PENDING: {class: 'text-warning', label: 'Pendente'},
                REJECTED: {class: 'text-danger', label: 'Rejeitado'},
                PAUSED: {class: 'text-warning', label: 'Pausado'},
                DISABLED: {class: 'text-danger', label: 'Desabilitado'},
                IN_APPEAL: {class: 'text-info', label: 'Em recurso'},
                PENDING_DELETION: {class: 'text-warning', label: 'Exclusão pendente'},
                UNKNOWN: {class: 'text-muted', label: 'Não informado'},
            }

            return statuses[status] || {
                class: 'text-muted',
                label: value || 'Não informado',
            }
        },
    },
}
</script>

<style>
.waba-template-row {
    cursor: pointer;
}
</style>
